export const translateStrangeObject = (arr: any, language: string) => {

    if (!arr || arr?.length === 0) return '';
    const foundName = arr?.find((item: any) => {
        const lang = item?.lang?.toLowerCase() === language;
        const Lang = item?.Lang?.toLowerCase() === language;
        return (lang || Lang) && item?.name !== '';
    })
    if (foundName) return foundName?.name || foundName?.Name;
    const foundAnyName = arr?.find((item: any) => {
        return item?.name?.length > 0;
    })
    if (foundAnyName) return foundAnyName?.name || foundAnyName?.Name;

    return arr[0]?.name || arr[0]?.Name || "";
}export const translateStrangeObject = (arr: any, language: string) => {

    if (!arr || arr?.length === 0) return '';
    const foundName = arr?.find((item: any) => {
        const lang = item?.lang?.toLowerCase() === language;
        const Lang = item?.Lang?.toLowerCase() === language;
        return (lang || Lang) && item?.name !== '';
    })
    if (foundName) return foundName?.name || foundName?.Name;
    const foundAnyName = arr?.find((item: any) => {
        return item?.name?.length > 0;
    })
    if (foundAnyName) return foundAnyName?.name || foundAnyName?.Name;

    return arr[0]?.name || arr[0]?.Name || "";
}